var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 14.0007H15.3332L7.99984 1.33398L0.666504 14.0007ZM8.6665 12.0007H7.33317V10.6673H8.6665V12.0007ZM8.6665 9.33398H7.33317V6.66732H8.6665V9.33398Z",
    fill: "#F2BD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTag);
export default __webpack_public_path__ + "static/media/warning-tag.4f2e8ac4.svg";
export { ForwardRef as ReactComponent };